<script lang="ts" setup>
import { CartService } from "~/services/CartService";
import LinkGray from "~/components/buttons/LinkGray.vue";
import AddedToCartModal from "@/components/common/cart/AddedToCartModal.vue";
import { Jsona } from "jsona";
import eventBus from "~/event-bus";
import { store } from "~/store";
// import { ItemCart } from "@/interfaces/ItemCart";
import auth from "~/services/AuthService";
import type { Modal } from "bootstrap";
import { AxiosError } from "axios";
import { computed, onMounted, ref } from "vue";
import googleAnalytics from "~/services/GoogleAnalyticsService";
import type CartAddedItemInfo from "~/interfaces/CartAddedItemInfo";
import { useMounted } from "@vueuse/core";

const props = defineProps({
  product: {
    type: Object,
    default: null,
  },
  btnAddFromSearch: {
    type: Boolean,
    default: false,
  },
  to: {
    type: String,
    default: "/",
  },
  btnType: {
    type: String,
    default: "link_gray",
  },
});

const emit = defineEmits(["update-cart-total-items", "clicked"]);
const cartService = new CartService();
const outOfStockModal = ref<Modal>();

const showModalAddProduct = ref(false);
const infoModalAddProduct = ref();
const errorsModalAddProduct = ref([]);
const outOfStockModalEl = ref<HTMLElement>();

const isUserAuthenticated = computed(() => auth.isUserLogged());
const mounted = useMounted();

// store.commit("cart/localStorageProducts");

onMounted(async () => {
  // cartService.getCartInitData();
  if (outOfStockModalEl.value) {
    const { Modal } = await import("bootstrap");
    outOfStockModal.value = new Modal(outOfStockModalEl.value);
  }
});

const addProductToCart = (qty: number = 1) => {
  emit("clicked");
  if (cartService && isUserAuthenticated.value) {
    cartService
      .addProduct(props.product.id, qty)
      .then((response) => {
        if (response) {
          const dataFormatter = new Jsona();
          if (response.data) {
            const data = dataFormatter.deserialize(response) as Array<unknown>;
            infoModalAddProduct.value = data;
            showModalAddProduct.value = true;
            eventBus.emit("update-cart-total-items");
            const fixedData = data[0] as {
              item_id: string;
              addedInfo: CartAddedItemInfo;
            };
            if (fixedData.addedInfo) {
              googleAnalytics.addToCartEvent(fixedData.addedInfo);
            }
          } else if (response.errors) {
            eventBus.emit("cart-error", { errors: response.errors });
          }
        }
      })
      .catch((err) => {
        const errors = err?.response?.data?.errors;
        if (errors && errors.length) {
          eventBus.emit("cart-error", { errors });
        } else if (err instanceof AxiosError && err.status === 422) {
          outOfStockModal.value?.show();
        }
      });
  } else if (cartService && !isUserAuthenticated.value) {
    cartService
      .validateAddProduct(props.product.id)
      .then((response) => {
        if (response) {
          const dataFormatter = new Jsona();
          if (response.data) {
            const data = dataFormatter.deserialize(response) as Array<unknown>;
            infoModalAddProduct.value = data;
            showModalAddProduct.value = true;

            const product = {
              productId: props.product.id,
              qty: 1,
            };
            // const productsInCart = store.getters["cart/getLocalProductInCart"];
            // // Verificar si el producto ya está en el carrito utilizando su productId
            // const existingProductIndex = productsInCart.findIndex(
            //   (product: ItemCart) => product.productId === props.product.id,
            // );
            // if (existingProductIndex === -1) {
            //   // Si el producto no está en el carrito, se agrega
            //   productsInCart.push({
            //     productId: props.product.id,
            //     qty: 1,
            //   });
            // } else {
            //   // Si el producto ya está en el carrito, se actualiza la información del producto
            //   productsInCart[existingProductIndex] = {
            //     productId: props.product.id,
            //     qty: productsInCart[existingProductIndex].qty + 1, // Incrementa la cantidad
            //   };
            // }
            store.dispatch("cart/addProductIdInLocal", product);
            const fixedData = data[0] as {
              item_id: string;
              addedInfo: CartAddedItemInfo;
            };
            store.dispatch("cart/addProductToCart", fixedData);
            eventBus.emit("update-cart-total-items");
            if (fixedData.addedInfo) {
              googleAnalytics.addToCartEvent(fixedData.addedInfo);
            }
          } else if (response.errors) {
            errorsModalAddProduct.value = response.errors;
            showModalAddProduct.value = true;
          }
        }
      })
      .catch((err) => {
        if (err instanceof AxiosError && err.status === 422) {
          outOfStockModal.value?.show();
        }
      });
  }
};
</script>

<template>
  <slot :click="addProductToCart">
    <link-gray
      v-if="btnType == 'link_gray'"
      component-svg="CartSvg"
      class="py-2"
      :btn-add-from-search="btnAddFromSearch"
      :to="'#'"
      @click.prevent.stop="addProductToCart()"
    />
  </slot>
  <template v-if="mounted">
    <added-to-cart-modal
      :show="showModalAddProduct"
      :info="infoModalAddProduct"
      :errors="errorsModalAddProduct"
      @update-show="(show: boolean) => (showModalAddProduct = show)"
    />
    <Teleport to="body">
      <div ref="outOfStockModalEl" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-2 fw-bold text-danger">
                AGOTADO TEMPORALMENTE
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body fw-semibold fs-4 text-secondary">
              Vuelve a intentar más tarde o busca un producto similar.
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-dark btn-lg"
                data-bs-dismiss="modal"
              >
                Seguir buscando
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </template>
</template>
